<template>
  <a  href="javascript:void(0);"
     class="btn"
    :class="[btnColor, 'status-circle', 'me-1']"
  ></a>

</template>

<script lang="js">
import {defineComponent} from 'vue'
export default defineComponent({
    name: "StatusgroupsIcon",
    data(){
        return {
            ready: false,
            btnColor: 'btn-primary',
            currentState: 0, //Not found in monitoring
            humanState: 'success',
            opacity:'',
        }
    },
    props: {
        status: 0
    },
    computed: {},
    mounted(){
        this.onServicestatusChange()
    },
    unmounted() {

    },

    methods: {

      onServicestatusChange() {

          this.currentState = Number(this.status);

          this.btnColor = 'btn-primary';
          this.opacity = '';

          // if (this.inMonitoring) {
          switch(this.currentState) {
            case 0:
              this.btnColor = 'btn-success';
              this.humanState = 'ok';
              break;

            case 1:
              this.btnColor = 'btn-warning';
              this.humanState = 'warning';
              break;

            case 2:
              this.btnColor = 'btn-danger';
              this.humanState = 'critical';
              break;

            case 3:
              this.btnColor = 'btn-secondary';
              this.humanState = 'unknown';
              break;
          }
          this.ready = true;
      },
    },



    watch: {
        status: {
            handler(newValue, oldValue) {
                this.onServicestatusChange();
            },
            deep: true,
        },
    }
});
</script>

<style scoped>
.status-circle {
  width: 15px;
  height: 15px;
  padding: 0;
  border-radius: 50%;
}

</style>
